import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {TokenRefreshService} from './token-refresh.service';

/**
 * Auth Guard for normal Users
 */
@Injectable()
export class AuthGuardService  {
  private router = inject(Router);
  private authService = inject(AuthService);
  private tokenRefresh = inject(TokenRefreshService);


  /**
   * Lässt die Route zu, wenn eine Sitzung besteht.
   *
   * <p>Ein abgelaufenes Access-Token heißt noch nicht abgemeldet: erst wird über das Refresh-Cookie
   * erneuert. Scheitert das, hat der {@link TokenRefreshService} bereits abgemeldet und nach
   * `/login` navigiert. Ist das Backend nicht erreichbar, wirft `getValidToken` – die Navigation
   * bricht dann mit diesem Fehler ab, der Nutzer bleibt angemeldet.
   */
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.isLoggedIn()) {
      this.authService.logout();
      this.router.navigate(['/login']);
      return false;
    }

    return (await this.tokenRefresh.getValidToken()) !== null;
  }
}
